module.exports = __webpack_public_path__ + "media/images/dummys/map_arena-a47898e41ac319aee7bf2d2471bab60a.png";